import { render, staticRenderFns } from "./StepChoicesEditor.vue?vue&type=template&id=5bbf86fc&scoped=true"
import script from "./StepChoicesEditor.vue?vue&type=script&lang=js"
export * from "./StepChoicesEditor.vue?vue&type=script&lang=js"
import style0 from "./StepChoicesEditor.vue?vue&type=style&index=0&id=5bbf86fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf86fc",
  null
  
)

export default component.exports